import React from 'react';
import bullVsBearBanner from './assets/bull-vs-bear-banner.webp';

const HeroBanner = () => {
  return (
    <div className="w-full relative mb-8">
      <img 
        src={bullVsBearBanner}   
        alt="Bull vs Bear Prediction" 
        className="w-full h-70 object-cover rounded-xl" 
        style={{ aspectRatio: '3/1' }} 
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent rounded-xl"></div>
      <div className="absolute bottom-0 left-0 p-6 w-full flex justify-start">
        <div className="bg-black/30 rounded-xl p-2 shadow-lg max-w-xl">
          <h1 className="text-2xl md:text-4xl font-bold text-white mb-2">Bull VS Bear</h1>
          <p className="text-gray-200 max-w-lg">
            Clash on a Battle Between Bullish and Bearish - Choose your Side
          </p>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;